import _ from 'lodash'
import * as React from 'react'

import * as THEMES from '../../constants/theme'
import { TinyText } from '../texts'
import { Styled } from './styled'

export const ThemeToneFrame = (props) => {
  const {
    theme,
    toneName,
    backgroundColor,
    backgroundRushColor,
    currentTone,
    changeTone
  } = props;
  return (
    <Styled.ThemeToneFrameContainer
      // eslint-disable-next-line react/jsx-no-bind
      onClick={() => changeTone(theme, toneName)}
      color={backgroundColor}
      currentTone={currentTone}
    >
      <Styled.ThemeToneFrameBorder color={backgroundRushColor} />
      <TinyText
        textAlign="center"
        color={theme === THEMES.DARK_THEME.name ? 'white' : 'darkBlue'}
      >
        {_.capitalize(toneName)}
      </TinyText>
    </Styled.ThemeToneFrameContainer>
  )
}
